import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M2 6h4v11H2zm5 13h10V4H7v15zM9 6h6v11H9V6zm9 0h4v11h-4z"
}), 'ViewCarouselOutlined');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ViewCarouselOutlined.js
// module id = 7076
// module chunks = 2